import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveAffiliateCode } from '../utils/affiliateLink';

export function useAffiliateLink() {
    const { search } = useLocation();
    return useMemo(() => resolveAffiliateCode(search), [search]);
}
